import { getElementOrLogError } from '../../utils/utils';
export class Order {
    constructor(template, events) {
        this.events = events;
        this.form = getElementOrLogError('.form', template.content).cloneNode(true);
        this.buttons = Array.from(this.form.querySelectorAll('.button_alt'));
        this.submitButton = getElementOrLogError('.order__button', this.form);
        this.errorMessages = getElementOrLogError('.form__errors', this.form);
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                this.paymentMethod = button.name;
                events.emit('order:paymentMethod', { method: button.name });
            });
        });
        this.form.addEventListener('input', (event) => {
            const target = event.target;
            this.events.emit('order:changeAddressValue', { field: target.name, value: target.value });
        });
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.events.emit('contacts:open');
        });
    }
    set paymentMethod(payment) {
        this.buttons.forEach(button => {
            button.classList.toggle('button_alt-active', button.name === payment);
        });
    }
    set isValid(value) {
        this.submitButton.disabled = !value;
    }
    render() {
        return this.form;
    }
}
